<template>
    <div id="app">
        <AuthProvider>
            <SocketProvider>
                <router-view />
            </SocketProvider>
        </AuthProvider>
    </div>
</template>

<script>
import { SocketProvider } from '@speechki-frontend/core/socket';
import { AuthProvider } from '@speechki-frontend/core/auth/components';

export default {
    components: {
        SocketProvider,
        AuthProvider,
    },
};
</script>

<style lang="scss" src="@speechki-frontend/shared/assets/scss/common.scss"></style>
